<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Prisreguleringer</h1>
    <div class="comp-header__actions">
      <button [admRequiresFeatureRole]="roles[Permission.PriceRegulationWrite]" mat-button type="button" (click)="openActionLog()">
        <mat-icon>list</mat-icon>
        <span>Hændelseslog</span>
      </button>
      <button
        [admRequiresFeatureRole]="roles[Permission.PriceRegulationWrite]"
        mat-flat-button
        color="primary"
        type="button"
        (click)="openCreatePriceRegulation()">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        <span>Opret prisregulering</span>
      </button>
    </div>
  </div>
  <div stickyHeaderCompTitleHelper>
    @if (state.focusedPriceRegulation()) {
      @let focusedPriceRegulation = state.focusedPriceRegulation();
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til prisregulering&nbsp;
        <strong>{{ focusedPriceRegulation?.name }}</strong>
        <button (click)="state.resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries">
        <adm-text-search placeholder="Søgeord" (search$)="querySearchInput($event)" [searchText]="state.filters().query ?? ''" />

        <adm-org-typeahead
          [initialId]="state.filters().organizationId ?? undefined"
          [resetTrigger]="state.resetAllFiltersTrigger()"
          (itemSelected)="organizationSelected($event)"
          (organizationsFetched)="organizationsFetched($event)" />

        <adm-admin-enum-select-list
          label="Vælg type"
          [enumObject]="typeOptions"
          [translatePipe]="translatePriceRegulationTypePipe"
          [initialValue]="state.filters().type"
          (enumChanged)="typeSelected($event)" />

        <div class="comp-header__filter-checkbox">
          <mat-slide-toggle [checked]="state.filters().onlyGlobal" (change)="toggleGlobalOnly($event.checked)" color="primary">
            Vis kun globale
          </mat-slide-toggle>
        </div>

        <button class="comp-header__reset-button" (click)="state.resetFilter()" mat-stroked-button>Nulstil</button>
      </div>
    }
  </div>
</div>
<div class="comp-main price-regulations-overview">
  <adm-price-regulations-list />
</div>
